import React from 'react';
import type { SVGProps } from 'react';

const IconLock = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 11 13" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.068 4.013a3.5 3.5 0 1 0-7 0v3h1v-3a2.5 2.5 0 1 1 5 0v3h1v-3Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.568 6.516v4.994c0 .554.449 1.003.995 1.003h8.01c.55 0 .995-.449.995-1.003V6.516c0-.554-.45-1.003-.996-1.003H1.563a.999.999 0 0 0-.995 1.003Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconLock;
